import { Component } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: true,
    imports: IMPORTS
})
export class AppComponent { }
